// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"348":"fd46ccbb6223d2b913e7","562":"c94d54e8bb9157945f8e","852":"abf2718f02dee3a964a0"}[chunkId] + ".js";
};